import { gql } from 'graphql-request'

export const UPDATE_BOOK_ISENDED = gql`
  mutation UpdateBookIsEnded($updateBookInput: UpdateBookInput!) {
    updateBook(updateBookInput: $updateBookInput) {
      id
    }
  }
`
